module.exports = __webpack_public_path__ + "static/img/14010006.72a93c33.png";